import Image from 'next/image';
import React from 'react';
import { ReactSketchCanvas, ReactSketchCanvasRef } from 'react-sketch-canvas';

interface CanvasProps {
  initialImage?: string;
  onDraw: (data: string) => void;
  clearCanvas?: number; // Change type to number
}

const Canvas: React.FC<CanvasProps> = ({
  initialImage,
  onDraw,
  clearCanvas = 0, // Default to 0
}) => {
  const canvasRef = React.useRef<ReactSketchCanvasRef>(null);

  const handleChange = async () => {
    const paths = await canvasRef.current?.exportPaths();

    // only respond if there are paths to draw (don't want to send a blank canvas)
    if (paths && paths.length) {
      const data = await canvasRef.current?.exportImage('png');
      if (data) {
        onDraw(data);
      }
    }
  };

  // Clear canvas when clearCanvas counter changes
  React.useEffect(() => {
    if (clearCanvas > 0 && canvasRef.current) {
      canvasRef.current.clearCanvas();
    }
  }, [clearCanvas]); // Effect will run whenever counter changes

  return (
    <div className='relative aspect-square w-full'>
      {/* INITIAL IMAGE */}
      {initialImage && (
        <Image
          src={initialImage}
          alt='initial image'
          fill
          className='absolute'
        />
      )}

      <div
        className='absolute left-0 top-0 h-full w-full'
        style={{ zIndex: 100 }}
      >
        <ReactSketchCanvas
          ref={canvasRef}
          strokeWidth={60}
          strokeColor='black'
          canvasColor='transparent'
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default Canvas;
